import {CreateOperationalEntityInput} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResult} from "../view-model";

export const toInProgressResult = (
  input: CreateOperationalEntityInput
): CreateResult => {
  return {
    status: "in-progress",
    caId: input.sources[0].sourceId,
    dbaName: input.organizationInformation.dbaName
  };
};
